<template>
  <div>
    <ListErrorMessages :appErrors="appErrors" />
    <router-view></router-view>
  </div>
</template>

<script>
import ListErrorMessages from '@/components/errors/list';

export default {
  components: { ListErrorMessages },
  data() {
    return {
      appErrors: [],
    };
  },

  created() {
    console.log("created oncall")
  },

  errorCaptured(err, component, info) {
    if (err.constructor.name != 'Error' || err.response == undefined) return;
    if (err.response.status !== 401) this.appErrors.push(err);
  },
};
</script>
